import { lazy, Suspense } from 'react';
import { runtime } from '../../platform/runtime';

// Loading the native route must never initialize the Maps JavaScript API.
const NativeMap = lazy(() => import('./NativeMap'));
const WebMap = lazy(() => import('./WebMap'));

export default function MapComponent(props) {
    const Component = runtime.isNative() ? NativeMap : WebMap;
    return <Suspense fallback={<div role="status">Loading map…</div>}><Component {...props} /></Suspense>;
}
